import { render, staticRenderFns } from "./invest.vue?vue&type=template&id=73404a4a&scoped=true&"
import script from "./invest.vue?vue&type=script&lang=js&"
export * from "./invest.vue?vue&type=script&lang=js&"
import style1 from "./invest.vue?vue&type=style&index=1&id=73404a4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73404a4a",
  null
  
)

export default component.exports